(function( $ ) {

    let limitResults = 4;

    if ($('.products-posts').length > 0) {
        $('.products-posts .elementor-post .elementor:hidden:lt('+ limitResults +')').css('display','inline-block');

        if ($('.products-posts .elementor-post').length <= limitResults) {
            $('.products-posts-container .elementor-widget-button').hide();
        }

        $('.products-posts-container .elementor-button').click(function(e) { 
            $('.products-posts .elementor-post .elementor').slideDown();
            $('.products-posts-container .elementor-widget-button').hide();
            e.preventDefault();
        });      
    } 
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/products.js